var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("user userConfiguration.changePassword"))),
          ]),
        ]
      ),
      _c("Auth-ChangePasswordForm", {
        attrs: { loading: _vm.loading },
        on: { submit: _vm.onSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }